import React from 'react';
import {
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Textarea,
} from '@axiom/ui';
import type { Account, FullCandidateAccount, User } from '@axiom/validation';

import {
  postDigitalBenchRequestRate,
  postDigitalBenchRequestUpdate,
} from '../../api/hubspot-api';

import type { MyBenchCardEngageModalType } from './my-bench-card-engage-modal-schema';
import { MyBenchCardEngageModalSchema } from './my-bench-card-engage-modal-schema';
import type { EditModalModeType } from './MyBenchCardSection';

export type MyBenchEditEngageModalProps = {
  account: Account;
  candidate: FullCandidateAccount;
  user: User;
  type: EditModalModeType;
  onClose: () => void;
};

export const MyBenchCardEngageModal = ({
  account,
  candidate,
  user,
  type,
  onClose,
}: MyBenchEditEngageModalProps) => {
  const handleOnSubmit = async (
    changeData: Partial<MyBenchCardEngageModalType>
  ) => {
    const payload = {
      fields: [
        { name: 'firstname', value: user.firstName },
        { name: 'lastname', value: user.lastName },
        {
          name: 'email',
          value: user.email,
        },
        {
          name: 'axiom_for_clients_account_display_name',
          value: account.calculatedName,
        },
        { name: 'axiom_for_clients_candidate_id', value: candidate.id },
        { name: 'description', value: changeData.description || '' },
      ],
    };

    await (type === 're-engage'
      ? postDigitalBenchRequestUpdate(payload)
      : postDigitalBenchRequestRate(payload));

    onClose();
  };

  return (
    <Form
      name="EDIT_ENGAGEMENT_MODAL_FORM"
      schema={MyBenchCardEngageModalSchema}
      initialValues={{ description: '' }}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => (
        <Modal name="EDIT_ENGAGEMENT_MODAL">
          <ModalHeader
            name="MODAL_HEADER"
            onClose={() => {
              onClose();
            }}
          >
            Confirm your request for {candidate.calculatedDisplayName}
          </ModalHeader>
          <ModalSection>
            <Textarea
              name="description"
              label="Add a message"
              description={
                type === 're-engage'
                  ? "Tell us more about what engagement details you'd like to update for this talent."
                  : "Anything else we should know about the type of legal work you're considering this talent for?"
              }
              full
            />
          </ModalSection>
          <ModalFooter>
            <Button
              variation="outline"
              name="CANCEL"
              onClick={() => {
                onClose();
              }}
            >
              Close
            </Button>
            <Button
              name="SUBMIT"
              onClick={async () => {
                await fireSubmit();
              }}
            >
              Submit
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Form>
  );
};
